import React from "react";

import Stack from "@mui/material/Stack";
import { Event } from "react-big-calendar";
import { useTranslation } from "react-i18next";

import { getOrderCustomerDisplayName } from "../../../../../../util/names";
import getColorByTask from "../../getColorByTask";
import { TaskTypeBadge } from "../../views/DiaryListView/Panel/TaskTypeBadge";
import { TaskBadgeProps } from "../types";
import { dayBadgeStyles } from "./styles";
import { useAppState } from "Context/StateContext";

interface Props {
  event: Event;
  style?: React.CSSProperties;
  onSelectEvent?: (event: Event, reactEvent: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

const Badge = (props: Props) => {
  const { event, style, onSelectEvent } = props;
  const { t: translate } = useTranslation();
  const { formatWithUserTimezone } = useAppState();

  const classes = dayBadgeStyles(
    getColorByTask(event.resource?.task?.type || "").background,
    Number(style?.top)
  )();

  const renderTaskType = () => <TaskTypeBadge value={event.resource.task.type} />;
  const renderCustomerName = () => (
    <span className={classes.customerName}>
      {getOrderCustomerDisplayName(event.resource?.order)}
    </span>
  );
  const renderTaskTime = () => (
    <div>
      <span className={classes.startsAt}>{translate("startsAt")}</span>
      <span className={classes.startDate}>
        {event.start ? formatWithUserTimezone(event.start, "hh:mmaaa") : ""}
      </span>
    </div>
  );

  return (
    <div
      data-cy={`taskBadge-${event.resource?.task?.id}`}
      className={classes.groupedCard}
      onClick={(htmlEvent) => onSelectEvent?.(event, htmlEvent)}
    >
      <div className={classes.container}>
        <div className={classes.row}>
          {renderTaskType()}
          {renderCustomerName()}
        </div>
        {renderTaskTime()}
      </div>
    </div>
  );
};

export const TaskBadgeDay = (props: TaskBadgeProps) => {
  const { event, style } = props;

  const singleEvent = event?.resource?.tasks[0];

  const classes = dayBadgeStyles(
    getColorByTask(singleEvent.resource?.task?.type || "").background,
    Number(style?.top)
  )();

  if (!singleEvent) return null;

  if (event.resource.group) {
    return (
      <Stack className={classes.stackCard} direction="row" spacing={1}>
        {event.resource.tasks.map((event: Event, index: number) => (
          <Badge key={index} {...props} event={event} />
        ))}
      </Stack>
    );
  }

  return (
    <div className={classes.stackCard}>
      <Badge {...props} event={singleEvent} />
    </div>
  );
};
